export default function Payment() {
    return (
        <main className="page page--contained payment-page" aria-labelledby="payment-heading">
            <header className="page-header page-header--flush payment-header">
                <h1 id="payment-heading" className="page-title">Payment Options</h1>
                <p className="page-subtitle payment-subtitle">
                    Pay using Venmo or Cashapp by scanning the QR codes below, or contact us by email for other payment options: livingroominquiries@proton.me
                </p>
            </header>
            <div className="cards-grid payment_qr_codes">
                <img className="payment_qr" src="/assets/venmo.png" alt="Venmo payment QR code" />
                <img className="payment_qr" src="/assets/cashapp.png" alt="Cash App payment QR code" />
            </div>
        </main>
    );
}
